import { SC_VERSION } from '../constants';
import StyleSheet from '../sheet';
import flatten from '../utils/flatten';
import generateName from '../utils/generateAlphabeticName';
import { hash, phash } from '../utils/hash';
import isStaticRules from '../utils/isStaticRules';
import { joinStringArray, joinStrings } from '../utils/joinStrings';
var SEED = hash(SC_VERSION);
/**
 * ComponentStyle is all the CSS-specific stuff, not the React-specific stuff.
 */
var ComponentStyle = /** @class */ (function () {
    function ComponentStyle(rules, componentId, baseStyle) {
        this.rules = rules;
        this.staticRulesId = '';
        this.isStatic =
            process.env.NODE_ENV === 'production' &&
                (baseStyle === undefined || baseStyle.isStatic) &&
                isStaticRules(rules);
        this.componentId = componentId;
        this.baseHash = phash(SEED, componentId);
        this.baseStyle = baseStyle;
        // NOTE: This registers the componentId, which ensures a consistent order
        // for this component's styles compared to others
        StyleSheet.registerId(componentId);
    }
    ComponentStyle.prototype.generateAndInjectStyles = function (executionContext, styleSheet, stylis) {
        var names = this.baseStyle
            ? this.baseStyle.generateAndInjectStyles(executionContext, styleSheet, stylis)
            : '';
        // force dynamic classnames if user-supplied stylis plugins are in use
        if (this.isStatic && !stylis.hash) {
            if (this.staticRulesId && styleSheet.hasNameForId(this.componentId, this.staticRulesId)) {
                names = joinStrings(names, this.staticRulesId);
            }
            else {
                var cssStatic = joinStringArray(flatten(this.rules, executionContext, styleSheet, stylis));
                var name_1 = generateName(phash(this.baseHash, cssStatic) >>> 0);
                if (!styleSheet.hasNameForId(this.componentId, name_1)) {
                    var cssStaticFormatted = stylis(cssStatic, ".".concat(name_1), undefined, this.componentId);
                    styleSheet.insertRules(this.componentId, name_1, cssStaticFormatted);
                }
                names = joinStrings(names, name_1);
                this.staticRulesId = name_1;
            }
        }
        else {
            var dynamicHash = phash(this.baseHash, stylis.hash);
            var css = '';
            for (var i = 0; i < this.rules.length; i++) {
                var partRule = this.rules[i];
                if (typeof partRule === 'string') {
                    css += partRule;
                    if (process.env.NODE_ENV !== 'production')
                        dynamicHash = phash(dynamicHash, partRule);
                }
                else if (partRule) {
                    var partString = joinStringArray(flatten(partRule, executionContext, styleSheet, stylis));
                    // The same value can switch positions in the array, so we include "i" in the hash.
                    dynamicHash = phash(dynamicHash, partString + i);
                    css += partString;
                }
            }
            if (css) {
                var name_2 = generateName(dynamicHash >>> 0);
                if (!styleSheet.hasNameForId(this.componentId, name_2)) {
                    styleSheet.insertRules(this.componentId, name_2, stylis(css, ".".concat(name_2), undefined, this.componentId));
                }
                names = joinStrings(names, name_2);
            }
        }
        return names;
    };
    return ComponentStyle;
}());
export default ComponentStyle;
//# sourceMappingURL=ComponentStyle.js.map